import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AnalyticsService } from 'src/app/services/analytics.service';

@Component({
  selector: 'app-modal-user-goal-state',
  templateUrl: './modal-user-goal-state.page.html',
  styleUrls: ['./modal-user-goal-state.page.scss'],
})
export class ModalUserGoalStatePage implements OnInit {

  @Input() goalsAcc; 

  constructor(public modalController: ModalController, private analyticsService: AnalyticsService) {
    this.analyticsService.AnalyticsServiceModalView('user-goal-state');
   }

  displayedColumns = ['descripcion', 'monto','fecha']

  ngOnInit() {
  }

  closeModal() {
    this.modalController.dismiss();
  }

}
